import React from "react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { dashboardLinks } from "@/components/lib/SidebarLinks";
import { LayoutDashboard } from "lucide-react";

function DashboardMain() {
  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={dashboardLinks} />}
      pageName={{ title: "Dashboard" }}
      // paths={[
      //   { name: "Dashboard", path: "/dashboard" },
      // ]}
    >
      <div className="container mx-auto flex flex-col items-center justify-center min-h-[70vh] px-4 text-center">
        <div className="max-w-md w-full bg-cblack4 border border-white/10 rounded-xl p-8 md:p-10 shadow-2xl flex flex-col items-center gap-6">
          <div className="h-16 w-16 rounded-2xl bg-cyellow/10 flex items-center justify-center text-cyellow border border-cyellow/20 shadow-[0_0_15px_rgba(251,191,36,0.1)]">
            <LayoutDashboard size={32} />
          </div>
          
          <div className="space-y-3">
            <h1 className="text-2xl font-bold text-white tracking-wide">
              Dashboard Main Panel
            </h1>
            <p className="text-cwhite3 text-sm leading-relaxed">
              Please click the sidebar items to view the corresponding report or analytics pages.
            </p>
          </div>
        </div>
      </div>
    </Layout2>
  );
}

export default DashboardMain;
